<template>
    <div>
        <v-overlay :value="caricamento">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text"
                >Notifiche Push</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="addNew" small v-bind="attrs" v-on="on">
                        <v-icon color="primary"> mdi-plus </v-icon>
                    </v-btn>
                </template>
                <span>Nuova Notifica Push</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        @click="setNotifiche"
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="ml-5"
                    >
                        <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                </template>
                <span>Salva Notifiche Push</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        @click="$router.push('/home/notice')"
                        small
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="error"> mdi-keyboard-backspace </v-icon>
                    </v-btn>
                </template>
                <span>Indietro</span>
            </v-tooltip>
        </v-toolbar>
        <v-data-table :items="notifiche.filter((e) => e.validita == 1)" :headers="headers">
            <template v-slot:[`item.modifica`]="{ item }">
                <v-btn small @click="modifica(item)">
                    <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`item.elimina`]="{ item, index }">
                <v-btn small @click="elimina(item, index)">
                    <v-icon color="error">mdi-close</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`item.inviato`]="{ item }">
                <v-icon :color="item.inviato == 1 ? 'success' : 'error'">{{
                    item.inviato == 1 ? "mdi-check" : "mdi-close"
                }}</v-icon>
            </template>
            <template v-slot:[`item.destinatario`]="{ item }">
                {{utenti?.filter((e) => e.id_utente == item.destinatario)[0]?.nominativo}}
            </template>
        </v-data-table>

        <v-dialog v-model="editDialog" width="50vw">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text"
                        >Modifica Notifica Push</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="mr-2"
                                v-on="on"
                                small
                                @click="editDialog = false"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Slava</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="editDialog = false" small>
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="4">
                            <v-autocomplete
                                label="Destinatario"
                                v-model="editItem.destinatario"
                                :items="utenti"
                                item-text="nominativo"
                                item-value="id_utente"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                label="Data Invio"
                                type="datetime-local"
                                v-model="editItem.data_inviare"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                label="Titolo"
                                v-model="editItem.titolo"
                            />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea
                                label="Messaggio"
                                v-model="editItem.messaggio"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            caricamento: false,
            editDialog: false,
            editItem: {},
            utenti: [],
            notifiche: [],
            headers: [
                {
                    text: "Modifica",
                    value: "modifica",
                },
                {
                    text: "Titolo",
                    value: "titolo",
                },
                {
                    text: "Destinatario",
                    value: "destinatario",
                },
                {
                    text: "Inviato",
                    value: "inviato",
                },
                {
                    text: "Elimina",
                    value: "elimina",
                },
            ],
        };
    },
    methods: {
        async getPersonale() {
            let richiesta = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getutenti",
                    token: localStorage.getItem("user_token"),
                },
            };

            await this.$store.dispatch("api", richiesta).then((res) => {
                this.utenti = res.data;
            });
        },
        async getNotifiche() {
            let request = {
                controller: "webpush",
                method: "POST",
                richiesta: {
                    action: "getnotifications",
                    token: localStorage.user_token,
                },
            };
            await this.$store.dispatch("api6", request).then((res) => {
                this.notifiche = res.data.result;
            });
        },
        async setNotifiche() {
            this.caricamento = true;
            let request = {
                controller: "webpush",
                method: "PUT",
                richiesta: {
                    action: "setnotifications",
                    notifications: this.notifiche,
                    token: localStorage.user_token,
                },
            };
            await this.$store.dispatch("api6", request).then((res) => {
                this.notifiche = res.data.result;
            });
            this.caricamento = false;
        },
        addNew() {
            this.notifiche.push({
                id_notification: -1,
                destinatario: null,
                data_inviare: "",
                titolo: "",
                messaggio: "",
                inviato: 0,
                validita: 1,
            });
            this.modifica(this.notifiche[this.notifiche.length - 1]);
        },
        modifica(item) {
            this.editItem = item;
            this.editDialog = true;
        },
        elimina(item, index) {
            if (item.id_notification == -1) {
                this.notifiche.splice(index, 1);
            } else {
                item.validita = 0;
            }
        },
    },
    async mounted() {
        this.caricamento = true;
        await this.getPersonale();
        await this.getNotifiche();
        this.caricamento = false;
    },
};
</script>

<style></style>
